import React, { ReactElement } from "react";

import styled from "styled-components";

import { IconButton } from "../../components/IconButton";
import { ChatIcon } from "../../components/Icons";

const StyledFloatingControls = styled.div`
  position: fixed;
  right: 24px;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
  z-index: 40;
`;

/* Chat-hub button (mirrors the app's .chat-hub-button): a contained
   IconButton, 48px, with the ChatIcon. */
const ChatHubButton = styled(IconButton)`
  && {
    width: 48px;
    height: 48px;
  }
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
`;

/** The bottom-right floating chat-hub button. */
export const FloatingControls = (): ReactElement => (
  <StyledFloatingControls>
    <ChatHubButton variant="contained" className="chat-hub-button">
      <ChatIcon />
    </ChatHubButton>
  </StyledFloatingControls>
);

FloatingControls.displayName = "FloatingControls";
